module.exports = __webpack_public_path__ + "static/media/tomMi.86cae78f.wav";